import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationComponent } from './pagination.component';
import {MatPaginatorModule} from '@angular/material';
import {FinzyFlexDirectiveModule} from '../../directives/finzy-flex/finzy-flex-directive.module';



@NgModule({
    declarations: [PaginationComponent],
    exports: [
        PaginationComponent
    ],
    imports: [
        CommonModule,
        MatPaginatorModule,
        FinzyFlexDirectiveModule
    ]
})
export class PaginationModule { }
